// src/components/ProductList.js

import React, { useEffect, useState } from 'react';

/**
 * URL base de la API. Ajustar según entorno.
 */
const BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

/**
 * Listado de productos con búsqueda y selección.
 * Optimizado para ocupar el alto completo del contenedor.
 */
function ProductList({ onSelect, selectedProduct, style }) {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [filter, setFilter] = useState('');

    useEffect(() => {
        setLoading(true);
        fetch(`${BASE_URL}/api/products`)
            .then(res => res.json())
            .then(setProducts)
            .catch(() => setError('Error al cargar productos'))
            .finally(() => setLoading(false));
    }, []);

    const filtered = products.filter(p => {
        if (!p) return false;
        const filterLower = filter.toLowerCase();
        return (
            (p.handle && p.handle.toLowerCase().includes(filterLower)) ||
            (p.sku && p.sku.toLowerCase().includes(filterLower)) ||
            (p.title && p.title.toLowerCase().includes(filterLower))
        );
    });

    const formatPrice = (price) => {
        if (price == null) return '';
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    };

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                minHeight: 0,
                ...style,
            }}
        >
            <div style={{ padding: '18px 18px 8px 18px', background: 'transparent' }}>
                <h3 style={{ margin: 0, color: '#1976d2', letterSpacing: 1, fontWeight: 700, fontSize: 22 }}>
                    <span role="img" aria-label="box">📦</span> Productos
                </h3>
                <input
                    type="text"
                    placeholder="Buscar por nombre, título o SKU..."
                    value={filter}
                    onChange={e => setFilter(e.target.value)}
                    style={{
                        width: '100%',
                        margin: '12px 0 0 0',
                        padding: 8,
                        borderRadius: 8,
                        border: '1px solid #b0bec5',
                        fontSize: 15,
                        background: '#f5faff',
                        outline: 'none',
                        transition: 'border 0.2s',
                    }}
                />
            </div>
            <div
                style={{
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    background: 'transparent',
                    padding: '0 8px 8px 8px',
                }}
            >
                {loading ? (
                    <div style={{ color: '#1976d2', marginTop: 30, textAlign: 'center' }}>
                        <span role="img" aria-label="loading">⏳</span> Cargando productos...
                    </div>
                ) : error ? (
                    <div style={{ color: 'red', marginTop: 30, textAlign: 'center' }}>{error}</div>
                ) : filtered.length === 0 ? (
                    <div style={{ color: '#888', marginTop: 30, textAlign: 'center' }}>
                        <span role="img" aria-label="notfound">😕</span> No se encontraron productos.
                    </div>
                ) : (
                    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                        {filtered.map(product => (
                            <li
                                key={product.id}
                                onClick={() => onSelect(product)}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 12,
                                    padding: '13px 8px',
                                    marginBottom: 6,
                                    background: selectedProduct && selectedProduct.id === product.id ? '#e3f2fd' : '#fff',
                                    borderRadius: 8,
                                    cursor: 'pointer',
                                    border: selectedProduct && selectedProduct.id === product.id
                                        ? '2px solid #1976d2'
                                        : '1px solid #e3e3e3',
                                    fontWeight: selectedProduct && selectedProduct.id === product.id ? 600 : 400,
                                    boxShadow: selectedProduct && selectedProduct.id === product.id
                                        ? '0 2px 8px #1976d233'
                                        : undefined,
                                    transition: 'background 0.2s, border 0.2s',
                                }}
                            >
                                {product.img ? (
                                    <img
                                        src={product.img}
                                        alt={product.handle || product.title}
                                        style={{
                                            width: 44,
                                            height: 44,
                                            objectFit: 'contain',
                                            borderRadius: 6,
                                            background: '#fff',
                                            border: '1px solid #eee',
                                            boxShadow: '0 1px 4px #e3f2fd22',
                                        }}
                                        onError={e => { e.target.style.display = 'none'; }}
                                    />
                                ) : (
                                    <div
                                        style={{
                                            width: 44,
                                            height: 44,
                                            background: '#e3e3e3',
                                            borderRadius: 6,
                                        }}
                                    />
                                )}
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <div
                                        style={{
                                            fontWeight: 600,
                                            color: '#222',
                                            fontSize: 16,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                        }}
                                    >
                                        {product.title || product.handle}
                                    </div>
                                    <div style={{ fontSize: 13, color: '#789', marginTop: 2 }}>
                                        SKU: <b>{product.sku || 'N/A'}</b> &nbsp;|&nbsp; Precio:&nbsp;
                                        <span style={{ color: '#1976d2', fontWeight: 700 }}>
                      {product.currency || ''} {formatPrice(product.price)}
                    </span>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
}

export default ProductList;
